module.exports = __webpack_public_path__ + "assets/img/yl_w_d_i_7.a4faf672.jpg";